import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { Router } from "@angular/router";
import { UserDataStoreService } from "./user-data-store.service";
import { SessionTimer } from '../models/session-timer';
import { RefreshSessionViewModel } from '../models/refresh-session-view-model';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoggedInUser } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class AppSettingDataService {

  private currentUserSubject: BehaviorSubject<LoggedInUser>;
  public currentUser: Observable<LoggedInUser>;
  constructor(
    private _httpService: HttpService,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
  ) {
  }

  public async GetSessionTimer(id: string): Promise<SessionTimer> {
    const httpResult = await this._httpService.apiGet<SessionTimer>(`AppSettingData/GetSessionTimer`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async ResetSessionTimer(): Promise<SessionTimer> {
    let participant = this._userDataStore.selectedParticipant.id;

    const refreshSessionViewModel: RefreshSessionViewModel = {
      participantId: participant,
      refreshToken: this._userDataStore.currentUserValue.refreshToken,
      token: this._userDataStore.currentUserValue.token
    };
    const httpResult = await this._httpService.apiPostRefreshToken<LoggedInUser>(`AppSettingData/ResetSessionTimer`, refreshSessionViewModel);
    if (httpResult && httpResult.body) {
      this._userDataStore.UpdateUser(httpResult.body);
      return httpResult.body.sessionTimer;
    }
    return null;
  }
}
